import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPlusMedium"><Path d="M11 13H4.5V11H11V4.5H13V11H19.5V13H13V19.5H11V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlusMedium;
